module.exports = __webpack_public_path__ + "img/a.b56ad86a.png";